import { render } from "./HomePage.vue?vue&type=template&id=34637b30&scoped=true"
const script = {}

import "./HomePage.vue?vue&type=style&index=0&id=34637b30&scoped=true&lang=scss"
import "./HomePage.vue?vue&type=style&index=1&id=34637b30&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34637b30"]])

export default __exports__